import React, { useState, useEffect } from 'react';
import BibliothequePlotly from '../BibliothequePlotly/BibliothequePlotly';
import { convertiUtsToDate } from '../GrapheXT/GrapheXT';
import { average } from '../GraphesMachinePosition/GraphesMachinePosition';

const GrapheGeoposition = ({
  configuration,
  donnees,
  viewobj_json_content,
  switchAfficherModifierIntervalle,
  dimensionWidth,
  dimensionHeight,
}) => {
  const [data, setData] = useState([]);
  const [layout, setLayout] = useState({});
  const [mapboxLayout, setMapboxLayout] = useState({});
  const [geoBounds, setGeoBounds] = useState({ zoom: 9 });

  useEffect(() => {
    if (configuration !== undefined && donnees !== undefined) {
      const newLayout = {
        font: { size: 14 },
        title: {
          text: configuration.title + '<br>' + configuration.subtitle,
          font: {
            color: '#3c3935',
          },
        },
        showlegend: true,
        legend: {
          orientation: 'h',
          x: 0,
          y: -0.0,
        },
        ...(viewobj_json_content === undefined || viewobj_json_content === null
          ? {}
          : viewobj_json_content.layout),
      };

      let positions_x;
      let positions_y;
      let newData = [];

      for (
        let indSetDonnees = 0;
        indSetDonnees < donnees.length;
        indSetDonnees++
      ) {
        if (donnees[indSetDonnees].prefix === 'x') {
          positions_x = donnees[indSetDonnees];
        } else if (donnees[indSetDonnees].prefix === 'y') {
          positions_y = donnees[indSetDonnees];
        }
      }

      if (positions_x !== undefined && positions_y !== undefined) {
        let nb_values = positions_y.y.length - 1;
        let centre_lon = average(positions_y.y);
        let centre_lat = average(positions_x.y);

        let newMapboxLayout = {
          lon: centre_lon,
          lat: centre_lat,
        };

        if (nb_values < 0) {
          nb_values = 0;
          centre_lon = 2;
          centre_lat = 46.9;
          setGeoBounds({
            center: {
              lon: centre_lon,
              lat: centre_lat,
            },
            zoom: 4.9,
          });
        }

        const markers_color = [...Array(nb_values).fill('#736e6e'), '#a6153e'];
        const markers_size = [...Array(nb_values).fill(5), 15];

        newData.push({
          type: 'scattermapbox',
          mode: 'markers+text+lines',
          lon: positions_y.y,
          lat: positions_x.y,
          line: {
            dash: 'dashdot',
            width: 3,
            color: '#679ef6',
          },
          marker: {
            symbol: 'circle',
            color: markers_color,
            size: markers_size,
            line: {
              color: '#ffffff',
              width: 6,
            },
          },
          name: positions_x.sensor_name,
          text: convertiUtsToDate(positions_x.x),
        });

        setMapboxLayout(newMapboxLayout);
        setData(newData);
        setLayout(newLayout);
      }
    }
  }, [configuration, donnees, viewobj_json_content]);

  return (
    <BibliothequePlotly
      data={data}
      layout={{
        ...layout,
        mapbox: {
          center: mapboxLayout,
          ...geoBounds,
          style: 'open-street-map',
        },
        responsive: true,
        ...viewobj_json_content,
      }}
      ouvrirPopupModifierIntervalle={switchAfficherModifierIntervalle}
      dimensionWidth={dimensionWidth}
      dimensionHeight={dimensionHeight}
      viewobj_json_content={viewobj_json_content}
    />
  );
};

export default GrapheGeoposition;
